export const GET_ALLALBUMS_LOADING = 'GET_ALLALBUMS_LOADING';
export const GET_ALLALBUMS_SUCCESS = 'GET_ALLALBUMS_SUCCESS';
export const GET_ALLALBUMS_FAILURE = 'GET_ALLALBUMS_FAILURE';


export const ADD_ALBUM_LOADING = 'ADD_ALBUM_LOADING';
export const ADD_ALBUM_SUCCESS = 'ADD_ALBUM_SUCCESS';
export const ADD_ALBUM_FAILURE = 'ADD_ALBUM_FAILURE';


export const GET_ALBUM_LOADING = 'GET_ALBUM_LOADING';
export const GET_ALBUM_SUCCESS = 'GET_ALBUM_SUCCESS';
export const GET_ALBUM_FAILURE = 'GET_ALBUM_FAILURE';


export const UPDATE_ALBUM_LOADING = 'UPDATE_ALBUM_LOADING';
export const UPDATE_ALBUM_SUCCESS = 'UPDATE_ALBUM_SUCCESS';
export const UPDATE_ALBUM_FAILURE = 'UPDATE_ALBUM_FAILURE';


export const DELETE_ALBUM_LOADING = 'DELETE_ALBUM_LOADING';
export const DELETE_ALBUM_SUCCESS = 'DELETE_ALBUM_SUCCESS';
export const DELETE_ALBUM_FAILURE = 'DELETE_ALBUM_FAILURE';

export const DEBOUNCE_ALBUMS_LOADING = 'DEBOUNCE_ALBUMS_LOADING';
export const DEBOUNCE_ALBUMS_SUCCESS = 'DEBOUNCE_ALBUMS_SUCCESS';
export const DEBOUNCE_ALBUMS_FAILURE = 'DEBOUNCE_ALBUMS_FAILURE';